import { useContext } from "react";
import { TableContext } from "../index";
import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";

export const useReportsTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onReportNameClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('name')
        })
    }

    const onDescriptionClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('description')
        })
    }

    const onCreatedByClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('createdBy')
        })
    }
    const onCreatedAtClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('date')
        })
    }


    return { hardReload, onReportNameClick, onDescriptionClick, onCreatedByClick, onCreatedAtClick }
}
